/**Child url for creates */
export const CREATE_URL = "create";

export const BY_ID = "/:id";

export const ADD_ITEM = "/add-items";

export const ITEMS = "/items";

export const APPLY_TO_FEES = "/apply-to-fees";

export const APPLY_TO_ITEMS = "/apply-to-items";

export const COLLECTION_URL = "/collection";

export const DINE_URL = "/dine-in";

export const DELIVERY_URL = "/delivery";

export const ISSUE_REFUND_URL = "/issue-refund";

export const SPECIFIC_ITEMS_REFUND_URL = "/specific-items-refund";

export const REFUND_REASONS_URL = "/refund-reasons";

export const EDIT_PERMISSIONS = "/edit-permissions";

export const DELETE_PERMISSIONS = '/delete-permisisons';

export const SETTINGS = '/settings'

export const GROUP_AREAS = '/areas'

export const GROUP_TIPPING = '/tipping' 

export const GROUP_IMAGES = '/images'

export const CHECK_USER_STATUS = "check-user-status";

export const SET_LOCATION = "/set-location"
